import * as React from "react";

import {
  usePlpPresenterForTheSortingMenu,
  useProductListPresentationModel,
  useProductListState,
} from "../providers";
import { IS_HORIZONTAL_FILTER_ENABLED } from "../flags";

export const DesktopSorting: React.FunctionComponent = () => {
  const { selectedSortingOption } = useProductListState();
  const { PlpSortingOptions } = useProductListPresentationModel();

  const { handleActionSortingOption } = usePlpPresenterForTheSortingMenu();

  const [showSortingMenu, setShowSortingMenu] = React.useState(false);

  const sortingDropdownButtonRef = React.useRef<HTMLButtonElement | null>(null);
  const sortingMenuRef = React.useRef<HTMLDivElement | null>(null);

  React.useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        showSortingMenu &&
        sortingDropdownButtonRef.current &&
        sortingMenuRef.current &&
        !sortingDropdownButtonRef.current?.contains(event.target as Node) &&
        !sortingMenuRef.current?.contains(event.target as Node)
      ) {
        setShowSortingMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showSortingMenu, sortingMenuRef]);

  const sortingMenuOptions = React.useMemo(() => {
    return PlpSortingOptions.map((option, index) => {
      const key = `sorting-option-${index}`;
      const isSelected = option.value === selectedSortingOption.value;

      const action: React.MouseEventHandler = () => {
        handleActionSortingOption(option);

        window.dataLayer.push({
          event: 'sort_by',
          value: option.label
        });
      };

      return (
        <button
          aria-label={`sort option ${option.label} ${
            isSelected ? "selected" : "unselected"
          }`}
          key={key}
          className={`option ${isSelected ? "selected" : ""}`}
          onClick={action}
        >
          <p>{option.label}</p>
        </button>
      );
    });
  }, [PlpSortingOptions, selectedSortingOption]);

  const onToggleMenu = () => {
    setShowSortingMenu(!showSortingMenu);
  };

  return (
    <button
      ref={sortingDropdownButtonRef}
      className={`desktop-sorting ${showSortingMenu ? "showing-menu" : ""}`}
      onClick={onToggleMenu}
      aria-label={`sorting by: ${selectedSortingOption.label}`}
    >
      <p>
        {IS_HORIZONTAL_FILTER_ENABLED ? (
          <React.Fragment>
            <span className="sort-label-prefix">Sort&nbsp;by:&nbsp;</span>
            {selectedSortingOption.label}
          </React.Fragment>
        ) : (
          selectedSortingOption.label
        )}
      </p>

      {IS_HORIZONTAL_FILTER_ENABLED ? (
        <div
          aria-label="sorting options"
          ref={sortingMenuRef}
          className={`sorting-menu ${showSortingMenu ? "show" : ""}`}
        >
          {sortingMenuOptions}
        </div>
      ) : (
        showSortingMenu && (
          <div
            aria-label="sorting options"
            ref={sortingMenuRef}
            className="sorting-menu"
          >
            {sortingMenuOptions}
          </div>
        )
      )}
    </button>
  );
};
